module.exports = __webpack_public_path__ + "img/sixpackcarrier88.1f9fc5ff.jpg";